import { IBaseMigrationStaffer } from '../../../interfaces';
import { StafferMappingHandler } from '../../../mappings/staff';
import {
  IPracticeWorksStaffer,
  PracticeWorksStaffer,
  StafferSourceEntity,
} from '../../source/entities/staff';

export class PracticeWorksStafferMappingHandler extends StafferMappingHandler<
  PracticeWorksStaffer,
  StafferSourceEntity
> {
  override sourceEntity = new StafferSourceEntity();
  translateFn = (record: IPracticeWorksStaffer): IBaseMigrationStaffer => {
    const name = `${record.firstName} ${record.surname}`;
    return {
      id: record.id,
      name: name,
      providerNo: record.licenseNumber,
    };
  };
}
